/** The `errorCause` IRES Cloud sends when it refuses to delete an appointment that was carried out. */
export const APPOINTMENT_ALREADY_COMPLETED_CAUSE = "AppointmentAlreadyCompleted";

/**
 * Whether IRES Cloud refused an appointment deletion because the appointment was already carried
 * out: `PUT /ires/v1/projectStatus` answers `409` with `errorCause: "AppointmentAlreadyCompleted"`.
 * Until 2026-11-03 it answered a generic 404, so the specific message never showed; an older Cloud
 * still reads as a plain failure here.
 */
export function isAppointmentAlreadyCompletedResponse(status: number, data: unknown): boolean {
  return (
    status === 409 &&
    typeof data === "object" &&
    data !== null &&
    (data as { errorCause?: unknown }).errorCause === APPOINTMENT_ALREADY_COMPLETED_CAUSE
  );
}
